<template>
    <div class="mallOrderWrap fc">
        <div class="products fc">
            <div v-show="!productList.length" class="basicInfo fr">
                <img :src="productInfo.logo" alt />
                <div class="info fc jsa">
                    <h3>{{productInfo.name}}</h3>
                    <span class="sku grey">{{skuInfo.name}}</span>
                    <div class="fr ac jsb">
                        <span class="grey">
                            <strong class="price">{{skuInfo.sellPrice}}</strong>元
                        </span>
                        <span class="grey">×{{productNum}}</span>
                    </div>
                </div>
            </div>
            <div
                v-show="productList.length"
                v-for="(item, index) in productList"
                :key="index"
                class="basicInfo fr"
            >
                <img :src="item.logo" alt />
                <div class="info fc jsa">
                    <h3>{{item.productName}}</h3>
                    <span class="sku grey">{{item.skuName}}</span>
                    <div class="fr ac jsb">
                        <span class="grey">
                            <strong class="price">{{item.sellPrice}}</strong>元
                        </span>
                        <span class="grey">×{{item.qty}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="section fc">
            <div class="row fr ac jsb">
                <span>商品总价</span>
                <span class="grey">
                    <strong class="price">{{totalPrice}}</strong>元
                </span>
            </div>
            <div class="row fr ac jsb">
                <span>数量</span>
                <span class="grey">×{{totalNum}}</span>
            </div>
            <div class="row fr ac jsb">
                <span>运费</span>
                <span class="grey">{{expressFee}}元</span>
            </div>
        </div>
        <div class="section fc">
            <div class="row fr ac jsb">
                <span>配送方式</span>
                <span class="express">普通快递</span>
            </div>
            <div
                v-if="addressList.length && selectedAddress.realname"
                @click="toAddressList"
                class="address fc"
            >
                <p>
                    <span>{{selectedAddress.realname}}</span>
                    <span>{{selectedAddress.mobile}}</span>
                </p>
                <p>
                    <span>{{selectedAddress.provincename}}</span>
                    <span>{{selectedAddress.cityname}}</span>
                    <span>{{selectedAddress.countyname}}</span>
                    <span>{{selectedAddress.address}}</span>
                </p>
            </div>
            <div v-if="!addressList.length" class="row fr ac jsb">
                <span>收货地址</span>
                <p @click="addAddress" class="newAddress fr ac">
                    <span class="tc">新增收货地址</span>
                    <img class="arrow" src="../../../static/imgs/movie/right.png" alt />
                </p>
            </div>
            <div v-show="needReceivedTime == 'Y'" class="row fr ac jsb">
                <span>配送时间</span>
                <span v-show="deliveryTime" class @click="togglePicker">{{deliveryTime}}</span>
                <span v-show="!deliveryTime" class="placeholder" @click="togglePicker">请选择</span>
            </div>
            <div
                v-show="birthdayTxt == 'Y'"
                class="row fr ac jsb"
                @click="$router.push('/birthdayCard')"
            >
                <span>生日牌信息</span>
                <span v-if="birthdayCard">{{birthdayCard}}</span>
                <span v-else class="placeholder">去填写</span>
            </div>
            <div class="row fr ac jsb">
                <span>备注</span>
                <input v-model="remark" class="remark" type="text" placeholder="此处填写备注信息" />
            </div>
        </div>
        <transition name="date-picker">
            <div class="pickerWrap" v-show="showPicker">
                <mt-picker :slots="slots" @change="onValuesChange" :itemHeight="80"></mt-picker>
            </div>
        </transition>
        <div v-show="showPicker" @click="togglePicker" class="shade"></div>
        <div class="footer fr ac">
            <div class="total fr ac">
                实付：
                <strong>{{totalPrice + expressFee}}元</strong>
                <span class="grey">（含运费）</span>
            </div>
            <div @click="createOrder" class="confirm center">提交订单</div>
        </div>
    </div>
</template>

<script>
import { Toast, Picker } from "mint-ui";
export default {
    data() {
        return {
            addressList: [],
            defaultAddress: {},
            selectedAddress: this.getLocal("selectedAddress")
                ? this.getLocal("selectedAddress")
                : this.defaultAddress,
            productInfo: this.$route.query.product
                ? JSON.parse(this.$route.query.product)
                : {},
            skuInfo: this.$route.query.sku
                ? JSON.parse(this.$route.query.sku)
                : {},
            productList: this.$route.query.productList
                ? JSON.parse(this.$route.query.productList)
                : [],
            productNum: this.$route.query.num ? this.$route.query.num : 0,
            remark: "",
            birthdayCard: "", //生日牌信息
            totalNum: 0,
            totalPrice: 0,
            expressFee: 0,
            productIds: "",
            cartIds: "",
            birthdayTxt: "N", // 是否填写生日牌信息
            needReceivedTime: "N", // 是否需要配送时间
            slots: [
                {
                    flex: 1,
                    values: [],
                    className: "slot1",
                    textAlign: "center",
                    defaultIndex: 0
                },
                {
                    divider: true,
                    content: "-",
                    className: "slot2"
                },
                {
                    flex: 1,
                    values: [
                        "10:00-11:00",
                        "11:00-12:00",
                        "12:00-13:00",
                        "13:00-14:00",
                        "14:00-15:00",
                        "15:00-16:00",
                        "16:00-17:00",
                        "17:00-18:00",
                        "18:00-19:00"
                    ],
                    className: "slot3",
                    textAlign: "center",
                    defaultIndex: 4
                }
            ],
            showPicker: false,
            deliveryTime: "",
            deliveryDate: "",
            deliveryHour: ""
        };
    },
    components: {},
    activated() {
        this.birthdayCard = this.getLocal("birthdayCard")
            ? this.getLocal("birthdayCard")
            : "";
        this.productInfo = this.$route.query.product
            ? JSON.parse(this.$route.query.product)
            : {};
        this.skuInfo = this.$route.query.sku
            ? JSON.parse(this.$route.query.sku)
            : {};
        this.productNum = this.$route.query.num ? this.$route.query.num : 0;
        this.productList = this.$route.query.productList
            ? JSON.parse(this.$route.query.productList)
            : [];
        let totalNum = 0,
            totalPrice = 0;
        this.productList.forEach(element => {
            totalNum += element.qty;
            totalPrice += element.qty * element.sellPrice;
        });
        this.totalNum = totalNum;
        this.totalPrice = totalPrice;

        let productIds = "",
            cartIds = "",
            idArr = [],
            cartIdArr = [];
        this.productList.forEach(element => {
            idArr.push(element.productId);
            cartIdArr.push(element.cartItemId);
        });
        productIds = idArr.join(",");
        cartIds = cartIdArr.join(",");
        this.productIds = productIds;
        this.cartIds = cartIds;

        for (let i of this.productList) {
            if (i.birthdaytxt == "Y") {
                this.birthdayTxt = "Y";
                break;
            } else {
                this.birthdayTxt = "N";
            }
        }
        for (let i of this.productList) {
            if (i.needReceivedTime == "Y") {
                this.needReceivedTime = "Y";
                break;
            } else {
                this.needReceivedTime = "N";
            }
        }

        this.getAddressList();

        console.log("productList", this.productList);
    },
    mounted() {
        let date = new Date();
        let dateArr = [];
        let nowHour = date.getHours();
        if (nowHour > 8 && nowHour < 21) {
            for (let i = 1; i <= 10; i++) {
                let weekDayArr = [
                    "周日",
                    "周一",
                    "周二",
                    "周三",
                    "周四",
                    "周五",
                    "周六"
                ];
                let hour = date.getHours();
                let milliseconds =
                    hour >= 9 && hour < 21
                        ? date.getTime() + 1000 * 60 * 60 * 24 * i
                        : date.getTime() + 1000 * 60 * 60 * 24 * (i + 1);
                let newDate = new Date(milliseconds);
                let weekDay = newDate.getDay(); //获取当前星期X(0-6,0代表星期天)
                let year = newDate.getFullYear(); //获取当前年
                let month = newDate.getMonth() + 1; //获取当前月
                let day = newDate.getDate(); //获取当前日
                let dateTxt =
                    year +
                    "年" +
                    month +
                    "月" +
                    day +
                    "日（" +
                    weekDayArr[weekDay] +
                    "）";
                dateArr.push(dateTxt);
            }
        } else {
            for (let i = 2; i <= 11; i++) {
                let weekDayArr = [
                    "周日",
                    "周一",
                    "周二",
                    "周三",
                    "周四",
                    "周五",
                    "周六"
                ];
                let hour = date.getHours();
                // let milliseconds = hour >= 9 && hour < 21 ? date.getTime() + 1000 * 60 * 60 * 24 * i : date.getTime() + 1000 * 60 * 60 * 24 * (i + 1);
                let milliseconds = date.getTime() + 1000 * 60 * 60 * 24 * i;
                let newDate = new Date(milliseconds);
                let weekDay = newDate.getDay(); //获取当前星期X(0-6,0代表星期天)
                let year = newDate.getFullYear(); //获取当前年
                let month = newDate.getMonth() + 1; //获取当前月
                let day = newDate.getDate(); //获取当前日
                let dateTxt =
                    year +
                    "年" +
                    month +
                    "月" +
                    day +
                    "日（" +
                    weekDayArr[weekDay] +
                    "）";
                dateArr.push(dateTxt);
            }
        }
        this.slots[0].values = dateArr;
        console.log(dateArr);
    },
    methods: {
        togglePicker() {
            this.showPicker = !this.showPicker;
        },
        addAddress() {
            this.$router.push("/newAddress");
        },
        toAddressList() {
            this.$router.push("/addressList");
        },
        getAddressList() {
            this.$post({
                method: "member.drama.express.address.list",
                auth_code: this.getLocal("auth_code")
            }).then(res => {
                if (res.success) {
                    this.addressList = res.data.addresslist;
                    for (let i of res.data.addresslist) {
                        if (i.isdefault == "Y") {
                            this.defaultAddress = i;
                            break;
                        }
                    }
                    this.selectedAddress = this.getLocal("selectedAddress")
                        ? this.getLocal("selectedAddress")
                        : this.defaultAddress;
                    if (this.selectedAddress.provincecode) {
                        this.getExpressFee();
                    }
                }
            });
        },
        createOrder() {
            let origin = this.$route.query.origin;
            if (this.needReceivedTime == "Y" && !this.deliveryTime) {
                Toast({
                    message: "请选择配送时间",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            }
            if (this.birthdayTxt == "Y" && !this.birthdayCard) {
                Toast({
                    message: "请输入生日牌信息",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            }
            
            if (origin == "product") {
                this.$post({
                    method: "member.mall.product.createOrder",
                    auth_code: this.getLocal("auth_code"),
                    productId: this.productIds,
                    skuId: this.productList[0].skuId,
                    addressid: this.selectedAddress.id,
                    qty: this.totalNum,
                    memberRemark: this.remark,
                    deliverydate: this.deliveryDate,
                    deliveryhour: this.deliveryHour,
                    birthdaytxt: this.birthdayCard
                }).then(res => {
                    if (res.success) {
                        let tradeno = res.data;
                        this.$router.push({
                            path: "/confirmOrder",
                            query: { tradeno: tradeno }
                        });
                    } else {
                        Toast({
                            message: res.error.desp,
                            position: "middle",
                            duration: 2000,
                            className: "toastBox"
                        });
                    }
                });
            } else {
                this.$post({
                    method: "member.mall.product.createOrderByCart",
                    auth_code: this.getLocal("auth_code"),
                    cartItemIds: this.cartIds,
                    addressid: this.selectedAddress.id,
                    memberRemark: this.remark
                }).then(res => {
                    if (res.success) {
                        let tradeno = res.data;
                        this.$router.push({
                            path: "/confirmOrder",
                            query: { tradeno: tradeno }
                        });
                    } else {
                        Toast({
                            message: res.error.desp,
                            position: "middle",
                            duration: 2000,
                            className: "toastBox"
                        });
                    }
                });
            }
        },
        // 运费
        getExpressFee() {
            // let productIds = "",
            //     cartIds = "",
            //     idArr = [],
            //     cartIdArr = [];
            // this.productList.forEach(element => {
            //     idArr.push(element.productId);
            //     cartIdArr.push(element.cartItemId);
            // });
            // productIds = idArr.join(",");
            // cartIds = cartIdArr.join(",");
            let origin = this.$route.query.origin;
            if (origin == "product") {
                this.$post({
                    method: "mall.product.expressfee",
                    auth_code: this.getLocal("auth_code"),
                    productId: this.productIds,
                    provincecode: this.selectedAddress.provincecode,
                    qty: this.totalNum
                }).then(res => {
                    if (res.success) {
                        this.expressFee = res.data;
                    }
                });
            } else {
                this.$post({
                    method: "mall.product.expressfeeByCart",
                    cartItemIds: this.cartIds,
                    provincecode: this.selectedAddress.provincecode,
                    auth_code: this.getLocal("auth_code")
                }).then(res => {
                    if (res.success) {
                        this.expressFee = res.data;
                    }
                });
            }
        },
        onValuesChange(picker, values) {
            this.deliveryTime = `${values[0]} ${values[1]}`;
            this.deliveryDate = values[0];
            this.deliveryHour = values[1];
        }
    }
};
</script>
<style lang="scss">
.mallOrderWrap {
    margin-bottom: 140px;
    .products {
        padding: 10px 30px;
        box-sizing: border-box;
        background: #fff;
        .basicInfo {
            width: 100%;
            font-size: 28px;
            padding: 10px 0;
            border-bottom: 1px solid #dededf;
            img {
                width: 200px;
                height: 200px;
            }
            .info {
                margin-left: 20px;
                width: calc(100% - 220px);
                h3 {
                    font-weight: bold;
                    line-height: 36px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }
                .price {
                    font-size: 36px;
                    color: #fc0;
                }
            }
        }
        .basicInfo:last-of-type {
            border-bottom: none;
        }
    }
    .section {
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        margin-top: 20px;
        background: #fff;
        .row {
            height: 100px;
            font-size: 28px;
            border-bottom: 1px solid #dededf;
            .newAddress {
                height: 100px;
                span {
                    height: 100px;
                    line-height: 100px;
                }
                .arrow {
                    width: 16px;
                    height: 28px;
                    margin: 5px 0 0 15px;
                }
            }
            .price {
                color: #fc0;
            }
            .remark {
                height: 100px;
                line-height: 100px;
                width: 80%;
            }
            .placeholder {
                color: #999;
            }
        }
        .row:last-of-type {
            border-bottom: none;
        }
        .address {
            padding: 20px 0;
            border-bottom: 1px solid #dededf;
            font-size: 28px;
            p {
                span {
                    display: inline-block;
                    line-height: 42px;
                    margin-right: 10px;
                }
            }
        }
    }
    .pickerWrap {
        background: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 8;
        width: 100%;
        .picker {
            .picker-item {
                font-size: 26px;
            }
            .picker-toolbar {
                height: 80px;
                border-bottom: 1px solid #dededf;
                .toolBar {
                    width: 100%;
                    padding: 0 30px;
                    box-sizing: border-box;
                    height: 80px;
                    font-size: 28px;
                    .confirmTxt {
                        color: #e42f46;
                    }
                }
            }
        }
    }
    .date-picker-enter {
        transform: translateY(960px);
    }
    .date-picker-enter-active {
        transition: all 0.5s;
    }
    .shade {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 4;
    }
    .footer {
        width: 100%;
        height: 120px;
        position: fixed;
        bottom: 0;
        .total {
            width: calc(100% - 30px);
            height: 120px;
            padding: 0 30px;
            box-sizing: border-box;
            background: #fff;
            font-size: 28px;
            strong {
                color: #fc0;
            }
        }
        .confirm {
            width: 300px;
            height: 120px;
            font-size: 32px;
            background-color: #fc0;
            color: #fff;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/mallOrderInfo.vue